import React from "react";

const ShootingStars = ({ width = 100, style = {} }) => {
  return (
    <div
      className="sidebar h-100 d-none d-md-block "
      style={{ ...style, width }}
    >
      <div className="night">
        {Array(12)
          .fill(0)
          .map(() => (
            <span className="shooting_star"></span>
          ))}
      </div>
    </div>
  );
};

export default ShootingStars;
